import { History } from "history";
import { combineReducers } from "redux";
import { reducer as formReducer } from 'redux-form'
import { RouterState, connectRouter } from 'connected-react-router'
import * as Asset from "./Asset";
import * as pressRelease from "./PressRelease";
import * as pressReleaseList from "./PressReleaseList";
import * as pressReleaseReserve from "./PressReleaseReserve";
import * as pressReleasePublish from "./PressReleasePublish";
import * as pressReleaseAI from "./PressReleaseAI";
import * as pressReleaseTag from "./PressReleaseTag";
import * as pressKit from "./PressKit";
import * as block from "./Block";
import * as Menu from "./Menu";
import * as Me from "./Me";
import * as Member from "./Member";
import * as Media from "./Media";
import * as Movie from "./Movie";
import * as Company from "./Company";
import * as Group from "./Group";
import * as Dialog from "./Dialog";
import * as SagaMonitor from "./SagaMonitor";
import * as Preview from "./Preview";
import * as Payment from "./Payment";
import * as PaymentHistory from "./PaymentHistory";
import * as Error from "./Error";
import * as Topic from "./Topic";
import * as Analytics from "./Analytics";
import * as Ticket from "./Ticket";
import * as Radar from './Radar';
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore'
import * as Briefing from './Briefing';
import * as BriefingList from './BriefingList';
import * as Plan from './Plan';
import * as Option from './Option';
import * as OrderInfo from './OrderInfo';



//model
import { TopicModel } from "../model/TopicModel";
import {RadarModel} from "../model/RadarModel";
import { analytics } from "firebase";
import { TicketModel } from "../model/TicketModel";

const rootReducer = (history: History) => combineReducers({
    router: connectRouter(history),
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    form: formReducer,
    ...pressRelease,
    ...pressReleaseList,
    ...pressReleaseReserve,
    ...pressReleasePublish,
    ...pressReleaseAI,
    ...pressReleaseTag,
    ...pressKit,
    ...Asset,
    ...block,
    ...Menu,
    ...Me,
    ...Member,
    ...Media,
    ...Movie,
    ...Company,
    ...Group,
    ...Dialog,
    ...SagaMonitor,
    ...Preview,
    ...Payment,
    ...PaymentHistory,
    ...Error,
    ...Topic,
    ...Analytics,
    ...Ticket,
    ...Briefing,
    ...BriefingList,
    ...Plan,
    ...Radar,
    ...Option,
    ...OrderInfo
})
export default rootReducer

export interface RootState {
    router: RouterState,
    form: any,
    firebase: any,
    firestore: any,
    pressRelease: any,
    pressReleaseList: any,
    pressReleaseReserve: any,
    pressReleasePublish: any,
    pressReleaseAI: any,
    pressReleaseTag: any,
    pressKit: any,
    asset: any,
    block: any,
    menu: any,
    me: any,
    member: any,
    movie: any,
    media: any,
    company: any,
    group: any,
    dialog: any,
    sagaMonitor: any,
    preview: any,
    payment: any,
    paymentHistory: any,
    error: any,
    topic: TopicModel,
    analytics:any,
    ticket: TicketModel,
    briefing: any,
    briefingList: any,
    plan: any,
    radar: RadarModel,
    option: any,
    orderInfo: any
}
